import { FIREBASE_INIT, LOGIN, LOGOUT } from '../actions/types';

const INITIAL_STATE = {
    firebaseApp: null,
    user: null
}

export default (state = INITIAL_STATE, action) => {
    console.log(action);

    switch (action.type) {
        case FIREBASE_INIT:
            return { ...state, firebaseApp: action.payload }

        case LOGIN:
            return { ...state, user: action.payload }

        case LOGOUT:
            return { ...state, user: null }

        default:
            return state;
    }
};